import { useMemo } from 'react';

import { useUsersByOxygenIdMap } from '.';
import { useFormsContext } from '../FormsProvider';

export default () => {
  const {
    forgeUserMapping: forgeMappingByPGID,
    pgProjectUsers: PGUsers,
    isLoadingPgProjectUsers,
    isLoadingForgeUserMapping,
  } = useFormsContext();
  const { data: usersMapByOxygenID, loading: isLoadingOxygenIdMap } =
    useUsersByOxygenIdMap();

  const isLoading = useMemo(
    () =>
      isLoadingOxygenIdMap ||
      isLoadingPgProjectUsers ||
      isLoadingForgeUserMapping,
    [isLoadingOxygenIdMap, isLoadingPgProjectUsers, isLoadingForgeUserMapping],
  );

  const data = useMemo(() => {
    const userPermissions = [];

    if (!isLoading) {
      for (const PGUser of PGUsers) {
        let companyId;
        let roleIds = [];
        const pgRoleId = PGUser.role_uid;
        const oxygenID = forgeMappingByPGID[PGUser.user_id];

        const user = oxygenID && usersMapByOxygenID[oxygenID];
        if (user) {
          companyId = user.companyId;
          roleIds = user.roleIds;
        }

        userPermissions.push({
          userPGID: PGUser.user_id,
          companyId,
          roleIds,
          pgRoleId,
        });
      }
    }

    return userPermissions;
  }, [PGUsers, forgeMappingByPGID, usersMapByOxygenID, isLoading]);

  return {
    data: isLoadingOxygenIdMap ? null : data,
    loading: isLoading,
  };
};
